export enum InputError {
  INVALID_COMBINATION = 'INVALID_COMBINATION',
  NEGATIVE_NUMBER = 'NEGATIVE_NUMBER',
}
